import styled from "styled-components";
import { theme } from "styles/theme";

// Containers
export const PageContainer = styled.div`
  padding: 1rem 0;
  height: 100%;
`;

export const UsersContainer = styled.div`
  padding: 1rem;
  background-color: ${theme.colors.surface};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.small};
`;

export const SearchInputContainer = styled.div`
  position: relative;
  width: 260px;
  min-width: 180px;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 100%;
    min-width: 0;
    flex: 1 1 100%;
  }

  .p-input-icon-left {
    width: 100%;
  }

  input {
    width: 100%;
    padding-left: 35px;
  }
`;

// Table elements
export const UserRow = styled.tr`
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${theme.colors.bgLight};
  }
`;

export const UserCell = styled.td`
  padding: 12px 8px;
  border-bottom: 1px solid ${theme.colors.borderLight || "#eee"};
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 12px 8px;
  border-bottom: 1px solid ${theme.colors.borderLight || "#eee"};
`;

// Pagination
export const PaginationContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
`;

// Status badges
export const StatusBadge = styled.span<{ status: string }>`
  background-color: ${({ status }) =>
    status === "active"
      ? theme.colors.statusActive || "#d4edda"
      : theme.colors.lightGrey};
  color: ${({ status }) =>
    status === "active"
      ? theme.colors.statusActiveText || "#155724"
      : theme.colors.darkGrey};
  padding: 0.25rem 0.75rem;
  border-radius: 100px;
  font-size: 0.8rem;
`;

export const RoleBadge = styled.span<{ role: string }>`
  background-color: ${({ role }) =>
    role === "ADMIN"
      ? theme.colors.tertiary
      : role === "DEALER"
        ? theme.colors.primary
        : theme.colors.lightGrey};
  color: ${({ role }) =>
    role === "ADMIN"
      ? theme.colors.onTertiary
      : role === "DEALER"
        ? theme.colors.onPrimary
        : theme.colors.darkGrey};
  padding: 0.25rem 0.75rem;
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: ${theme.fontWeights.medium};
  text-transform: capitalize;
`;

// Responsive components for mobile/tablet
export const ResponsiveTableWrapper = styled.div`
  @media (max-width: ${theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const UsersGrid = styled.div`
  display: none;

  @media (max-width: ${theme.breakpoints.tablet}) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    gap: 0.75rem;
  }
`;

export const UserCard = styled.div`
  background-color: ${theme.colors.surface};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.small};
  padding: 1rem;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }
`;

export const UserCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
`;

export const UserCardTitle = styled.h3`
  color: ${theme.colors.tertiary};
  margin: 0;
  font-size: 1.1rem;
  font-weight: ${theme.fontWeights.medium};
`;

export const UserCardContent = styled.div`
  margin-bottom: 1rem;
`;

export const UserCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const UserCardInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
  border-bottom: 1px solid ${theme.colors.borderLight};

  &:last-child {
    border-bottom: none;
  }
`;

export const UserCardLabel = styled.span`
  color: ${theme.colors.textSecondary};
  font-size: 0.875rem;
  font-weight: ${theme.fontWeights.medium};
`;

export const UserCardValue = styled.span`
  color: ${theme.colors.textPrimary};
  font-size: 0.875rem;
  text-align: right;
`;

export const UserCardBadges = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const DeviceLink = styled.span`
  color: ${theme.colors.tertiary || "#007bff"};
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.875rem;

  &:hover {
    color: ${theme.colors.primary || "#0056b3"};
  }
`;
